export enum MessageCenterPaneIds {
    MessageCenterPane = 'single-spa-application:message-center',
    MessageCenterWrapper = 'message-center-wrapper',
    SiteBody = 'vp-site-body',
    SupportBtn = 'SupportBtn',
    ChatBtn = 'ChatBtn'
}
